import { Subject } from "rxjs";
export var cartToggleSubject = new Subject();
export var creditCartSubject = new Subject();
export var cartStore = {
    items: [],
    couponCode: null,
    pointUsage: false,
    agreement: false,
};
